import { useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import ErrorBoundary from './components/common/ErrorBoundary';
import userContext from './configs/context/context';
import { AuthProvider } from './components/common/AuthProvider';
import Layout from './components/common/Layout';
import HomePage from './components/common/HomePage';
import Orders from './components/page/orders/Orders';
// import Wholesale from './components/page/wholesale/Wholesale';
import CustomerPage from './components/page/customers/CustomerPage';
import Categories from './components/page/category/Categories';
import LoginPage from './components/forms/Login';
import CreateProducts from './components/forms/CreateProducts';
import SubCategories from './components/page/subcategories/SubCategories';
import Quotationpage from './components/page/Quotation/Quotation';
import Menu from './components/page/menus/Menu';
import InquiriesPage from './components/page/enquiry/Enquiry';
import ReportPage from './components/page/reportspage/ReportPage';
import ImageSlider from './components/page/image';
import MenuEventManagement from './components/page/eventtype/Type';
import BookingList from './components/page/Booking/BookingList';
import ProtectedRoute from './components/common/ProtectedRoute';
import QuotationViewDialog from './components/page/Quotation/QuoatationView';
import OurEventsAdmin from './components/page/OurEvents/page';
// import QuotationModal from './components/page/Quotation/quotationFrom';
// import QuotationEditForm from './components/page/Quotation/quotationEditForm';
import CreateQuotationPage from './components/page/Quotation/quotationCreateFrom';
import EditQuotationPage from './components/page/Quotation/quotationEditForm';
// import Quotationspage from './components/page/Quotation/Quotation';

function App() {
	const [cart, setCart] = useState([]);
	const [categoryPopup, setCategoryPopup] = useState(false);
	const defaultValue = {
		cart,
		setCart,
		setCategoryPopup,
		categoryPopup,
	};

	return (
		<ErrorBoundary>
			<userContext.Provider value={defaultValue}>
				<AuthProvider>
					<BrowserRouter>
						<Routes>
							<Route element={<ProtectedRoute />}>
								<Route path="/" element={<Layout />}>
									<Route path="/" element={<HomePage />} />
									<Route path="/category" element={<Categories />} />
									<Route path="/sub-categories" element={<SubCategories />} />
									<Route path="/product/create" element={<CreateProducts />} />
									<Route path="/order" element={<Orders />} />
									<Route path="/fixed-menu" element={<Menu />} />
									<Route path="/quotation" element={<Quotationpage />} />
									<Route
										path="/quotation/:id"
										element={<QuotationViewDialog />}
									/>
									<Route
										path="/quotation/edit/:id"
										element={<EditQuotationPage />}
									/>
									<Route
										path="/quotation/create"
										element={<CreateQuotationPage />}
									/>
									<Route path="/enquiries" element={<InquiriesPage />} />
									<Route path="/report" element={<ReportPage />} />
									<Route path="/event-type" element={<MenuEventManagement />} />
									<Route path="/booking" element={<BookingList />} />
									<Route path="/our-events" element={<OurEventsAdmin />} />
									<Route path="/customer" element={<CustomerPage />} />
									<Route path="/img" element={<ImageSlider />} />
								</Route>
							</Route>
							<Route path="/login" element={<LoginPage />} />
						</Routes>
					</BrowserRouter>
				</AuthProvider>
			</userContext.Provider>
		</ErrorBoundary>
	);
}

export default App;
